export const maskJoinEn = {
  joinCount: '{count} masks selected',
  joinCountOne: '1 mask selected',
  joinFinish: 'Join selected masks',
  joinHelp: 'Pick at least two masks on this image or in the object list. Space or Enter toggles a focused row; Enter on the image joins. The first pick keeps its attributes.',
  joinPrimary: 'Keeps attributes',
  joinAttributesKept: 'The first mask’s values will be kept. These other values will be discarded:',
  joinAttributeConflict: '{name}: keep {kept}; discard {discarded}',
  joinUnanswered: 'unanswered',
  joinSelectionChanged: 'The image, annotations or selection eligibility changed. Mask joining was cancelled; select the masks again.',
  joinTooLarge: 'These masks are too complex to join. Try selecting fewer masks.',
  joinUnavailable_missing: 'This mask is no longer in the annotation set.',
  joinUnavailable_readOnly: 'These annotations are read-only.',
  joinUnavailable_mask: 'Only masks can be joined.',
  joinUnavailable_locked: 'Unlock this mask before joining it.',
  joinUnavailable_hidden: 'Show this mask before joining it.',
  joinUnavailable_label: 'Select masks of the same label.',
  joinUnavailable_origin: 'These masks have different origins. Join manual masks together, or masks from the same model prediction with identical origin information.',
}

export const maskJoinDe: Record<keyof typeof maskJoinEn, string> = {
  joinCount: '{count} Masken ausgewählt',
  joinCountOne: '1 Maske ausgewählt',
  joinFinish: 'Ausgewählte Masken verbinden',
  joinHelp: 'Mindestens zwei Masken im aktiven Bild oder in der Objektliste auswählen. Leertaste oder Enter schaltet die fokussierte Zeile um; Enter im Bild verbindet. Die erste Auswahl behält ihre Attribute.',
  joinPrimary: 'Attribute bleiben',
  joinAttributesKept: 'Die Werte der ersten Maske bleiben erhalten. Diese anderen Werte gehen verloren:',
  joinAttributeConflict: '{name}: {kept} behalten; {discarded} verwerfen',
  joinUnanswered: 'unbeantwortet',
  joinSelectionChanged: 'Bild, Annotationen oder Auswahlmöglichkeiten haben sich geändert. Das Verbinden wurde abgebrochen; Masken erneut auswählen.',
  joinTooLarge: 'Diese Masken sind zu komplex zum Verbinden. Weniger Masken auswählen.',
  joinUnavailable_missing: 'Diese Maske ist nicht mehr im Annotationssatz.',
  joinUnavailable_readOnly: 'Diese Annotationen sind schreibgeschützt.',
  joinUnavailable_mask: 'Nur Masken lassen sich verbinden.',
  joinUnavailable_locked: 'Diese Maske vor dem Verbinden entsperren.',
  joinUnavailable_hidden: 'Diese Maske vor dem Verbinden einblenden.',
  joinUnavailable_label: 'Masken derselben Klasse auswählen.',
  joinUnavailable_origin: 'Diese Masken haben unterschiedliche Ursprünge. Manuelle Masken miteinander verbinden oder Masken derselben Modellvorhersage mit identischen Herkunftsangaben.',
}
